import { Button } from '@e2n/ui';
import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoPopover, type PopoverSeite } from './InfoPopover.tsx';

const ANZEIGEDAUER_MS = 2000;
const MASKIERUNG = '•••••';

export function ApiKeyMaskierung({ className }: { className?: string }) {
  return <span className={className}>{MASKIERUNG}</span>;
}

export function ApiKeyInfo({ seite }: { seite: PopoverSeite }) {
  const { t } = useTranslation();

  return (
    <InfoPopover
      seite={seite}
      text={t('domain.e2nApi.zugaenge.tabelle.apiKeyInfo')}
      label={t('domain.e2nApi.zugaenge.tabelle.apiKeyInfoLabel')}
    />
  );
}

export function ApiKeyKopierenButton({ apiKey }: { apiKey: string }) {
  const { t } = useTranslation();
  const [kopiert, setKopiert] = useState(false);

  async function handleKopieren() {
    try {
      await navigator.clipboard.writeText(apiKey);
      setKopiert(true);
      setTimeout(() => setKopiert(false), ANZEIGEDAUER_MS);
    } catch {
      console.error('Fehler beim Kopieren in die Zwischenablage');
    }
  }

  return (
    <Button
      variant="icon"
      size="icon"
      onClick={handleKopieren}
      aria-label={t(
        kopiert
          ? 'domain.e2nApi.zugaenge.tabelle.apiKeyKopiert'
          : 'domain.e2nApi.zugaenge.tabelle.apiKeyKopieren',
      )}>
      <FontAwesomeIcon icon={kopiert ? faCheck : faCopy} />
    </Button>
  );
}

export function ApiKeyClipboard({ apiKey }: { apiKey: string }) {
  return (
    <span className="flex items-center gap-1">
      <ApiKeyMaskierung className="flex h-10 w-12 items-center justify-center rounded-md bg-neutrals-200 text-sm text-neutrals-900" />
      <ApiKeyKopierenButton apiKey={apiKey} />
    </span>
  );
}
